var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaygroundPsychflex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 340,
    viewBox: "0 0 284 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_20)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 340
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.921 1H141.417C138.103 1 135.417 3.6863 135.417 7.00001V17.1151C135.417 20.4288 138.103 23.1151 141.417 23.1151H141.921C145.235 23.1151 147.921 20.4288 147.921 17.1151V7C147.921 3.68629 145.235 1 141.921 1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.474 19.7377L112.855 9.96745C111.997 6.76674 108.707 4.86753 105.507 5.72545L105.02 5.85593C101.819 6.71385 99.9198 10.004 100.778 13.2047L103.397 22.9749C104.254 26.1757 107.545 28.0749 110.745 27.2169L111.232 27.0865C114.433 26.2285 116.332 22.9384 115.474 19.7377Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8002 30.6735L79.7462 21.9173C78.0897 19.0473 74.4202 18.0635 71.5502 19.7201L71.1137 19.972C68.2437 21.6285 67.26 25.298 68.9165 28.168L73.9704 36.9242C75.627 39.7942 79.2964 40.7779 82.1664 39.1214L82.603 38.8695C85.473 37.2129 86.4567 33.5435 84.8002 30.6735Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0201 49.1742L50.8697 42.0198C48.5273 39.676 44.7283 39.6749 42.3845 42.0174L42.0281 42.3737C39.6843 44.7161 39.6832 48.5151 42.0257 50.8589L49.176 58.0133C51.5185 60.3571 55.3175 60.3582 57.6612 58.0157L58.0177 57.6594C60.3615 55.317 60.3626 51.518 58.0201 49.1742Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9219 73.9719L28.1645 68.9156C25.2948 67.2588 21.6253 68.2419 19.9685 71.1116L19.7165 71.5481C18.0596 74.4177 19.0428 78.0872 21.9125 79.7441L30.6699 84.8003C33.5396 86.4572 37.2091 85.474 38.8659 82.6043L39.1179 82.1679C40.7748 79.2982 39.7916 75.6287 36.9219 73.9719Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.971 103.384L13.2033 100.767C10.0026 99.909 6.71268 101.808 5.85509 105.009L5.72466 105.496C4.86707 108.697 6.76655 111.987 9.96726 112.844L19.7349 115.461C22.9356 116.319 26.2255 114.419 27.0831 111.219L27.2136 110.732C28.0712 107.531 26.1717 104.241 22.971 103.384Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1125 135.412H7C3.68629 135.412 1 138.098 1 141.412V141.916C1 145.229 3.6863 147.916 7.00001 147.916H17.1125C20.4262 147.916 23.1125 145.229 23.1125 141.916V141.412C23.1125 138.098 20.4262 135.412 17.1125 135.412Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.338 135.422H266.223C262.909 135.422 260.223 138.109 260.223 141.422V141.926C260.223 145.24 262.909 147.926 266.223 147.926H276.338C279.651 147.926 282.338 145.24 282.338 141.926V141.422C282.338 138.109 279.651 135.422 276.338 135.422Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.625 105.503L277.494 105.014C276.636 101.813 273.346 99.9136 270.145 100.771L260.38 103.388C257.179 104.245 255.28 107.535 256.138 110.736L256.269 111.225C257.126 114.426 260.416 116.325 263.617 115.468L273.382 112.851C276.583 111.994 278.482 108.704 277.625 105.503Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.613 71.5528L263.361 71.1164C261.704 68.2467 258.035 67.2635 255.165 68.9204L246.408 73.9766C243.538 75.6335 242.555 79.303 244.212 82.1726L244.464 82.6091C246.121 85.4788 249.79 86.4619 252.66 84.8051L261.417 79.7488C264.287 78.092 265.27 74.4225 263.613 71.5528Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.316 42.3851L240.959 42.0287C238.616 39.6856 234.817 39.6856 232.474 42.0287L225.322 49.1811C222.979 51.5243 222.979 55.3232 225.322 57.6663L225.678 58.0227C228.021 60.3658 231.82 60.3658 234.163 58.0227L241.316 50.8703C243.659 48.5272 243.659 44.7282 241.316 42.3851Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.228 19.9661L211.791 19.7142C208.921 18.0583 205.252 19.0429 203.596 21.9132L198.544 30.6704C196.888 33.5407 197.873 37.2099 200.743 38.8658L201.18 39.1176C204.05 40.7735 207.719 39.789 209.375 36.9187L214.427 28.1615C216.083 25.2911 215.098 21.6219 212.228 19.9661Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.321 5.86088L177.834 5.73044C174.634 4.87286 171.344 6.77233 170.486 9.97304L167.87 19.7382C167.012 22.9389 168.912 26.2288 172.112 27.0864L172.599 27.2168C175.8 28.0744 179.09 26.1749 179.947 22.9742L182.564 13.2091C183.421 10.0084 181.522 6.71847 178.321 5.86088Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5847 246.776L85.5796 246.769L85.5744 246.762C54.1777 206.363 48.1133 168.19 46.9598 156.16C46.7023 153.474 44.4444 151.294 41.6942 151.294H39.1902C36.4371 151.294 34.1944 153.524 34.4515 156.353C35.6205 169.219 41.9436 210.992 75.6416 254.358C80.5218 260.87 82.4249 271.434 83.1166 279.857C83.2193 281.108 83.7729 282.289 84.701 283.157L87.6362 285.901C88.5623 286.767 89.7829 287.248 91.0507 287.248H190.334C191.596 287.248 192.811 286.771 193.736 285.913L196.673 283.186C197.601 282.324 198.159 281.149 198.268 279.902C199.008 271.472 200.971 260.898 205.834 254.43C239.591 210.962 245.926 169.213 247.098 156.353C247.356 153.524 245.113 151.294 242.36 151.294H239.856C237.106 151.294 234.848 153.474 234.589 156.16C233.434 168.183 227.358 206.331 195.907 246.828L195.903 246.834L195.898 246.84C190.588 253.893 187.937 263.511 186.62 272.069C186.383 273.608 185.087 274.744 183.575 274.744H97.8501C96.3317 274.744 95.0322 273.599 94.8018 272.053C93.5262 263.492 90.9118 253.875 85.5847 246.776Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.011 275.929H80.5359C77.2222 275.929 74.5359 278.615 74.5359 281.929V282.433C74.5359 285.746 77.2222 288.433 80.5359 288.433H201.011C204.325 288.433 207.011 285.746 207.011 282.433V281.929C207.011 278.615 204.325 275.929 201.011 275.929Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.011 301.278H80.5359C77.2222 301.278 74.5359 303.964 74.5359 307.278V307.782C74.5359 311.095 77.2222 313.782 80.5359 313.782H201.011C204.325 313.782 207.011 311.095 207.011 307.782V307.278C207.011 303.964 204.325 301.278 201.011 301.278Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.004 326.624H100.546C97.2322 326.624 94.5459 329.31 94.5459 332.624V333.128C94.5459 336.441 97.2322 339.128 100.546 339.128H181.004C184.317 339.128 187.004 336.441 187.004 333.128V332.624C187.004 329.31 184.317 326.624 181.004 326.624Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.396 107.016H104.9C108.136 107.016 111.104 104.309 110.335 100.837C107.963 90.1284 98.3928 82.0934 86.9774 82.0934H74.7798C71.4661 82.0934 68.7798 84.7797 68.7798 88.0934V88.5974C68.7798 91.9111 71.4661 94.5974 74.7798 94.5974H86.9774C91.6819 94.5974 95.737 97.4612 97.4827 101.543C98.6287 104.222 101.034 107.016 104.396 107.016Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.637 280.171H136.637V279.171V87.6915C136.637 69.6266 121.944 54.9301 103.881 54.9301C85.8134 54.9301 71.1169 69.6264 71.1169 87.6915V88.6915H72.1169H82.6209H83.6209V87.6915C83.6209 76.5215 92.7107 67.434 103.881 67.434C115.046 67.434 124.133 76.5237 124.133 87.6915V279.171V280.171H125.133H135.637Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2139 106.087C50.2139 117.5 58.2494 127.07 68.9605 129.442C72.4323 130.211 75.1388 127.242 75.1388 124.006V123.502C75.1388 120.141 72.3456 117.735 69.6654 116.59C65.5821 114.845 62.7179 110.791 62.7179 106.087C62.7179 99.7874 67.8426 94.6629 74.1388 94.6629C76.7346 94.6629 78.8389 92.5586 78.8389 89.9629V86.859C78.8389 84.2632 76.7346 82.1589 74.1388 82.1589C60.9448 82.1589 50.2139 92.8928 50.2139 106.087Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3306 144.337H44.8346C48.1962 144.337 50.624 141.571 51.6128 138.762C53.5049 133.387 58.6326 129.529 64.6399 129.529H68.2401C71.5538 129.529 74.2401 126.842 74.2401 123.529V123.025C74.2401 119.711 71.5538 117.025 68.2401 117.025H64.6399C51.8961 117.025 41.2457 126.128 38.8395 138.172C38.1476 141.635 41.0851 144.337 44.3306 144.337Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.649 107.01H177.153C180.515 107.01 182.92 104.217 184.067 101.538C185.812 97.4584 189.867 94.5974 194.572 94.5974H206.767C210.08 94.5974 212.767 91.9111 212.767 88.5974V88.0934C212.767 84.7797 210.08 82.0934 206.767 82.0934H194.572C183.157 82.0934 173.587 90.1257 171.214 100.832C170.445 104.304 173.413 107.01 176.649 107.01Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.409 280.166H157.409V279.166V87.6915C157.409 76.5215 166.499 67.434 177.669 67.434C188.839 67.434 197.929 76.524 197.929 87.6915V88.6915H198.929H209.433H210.433V87.6915C210.433 69.6264 195.736 54.9301 177.669 54.9301C159.601 54.9301 144.905 69.6264 144.905 87.6915V279.166V280.166H145.905H156.409Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.408 124.006V123.502C206.408 120.141 209.201 117.735 211.882 116.591C215.967 114.846 218.832 110.792 218.832 106.087C218.832 99.7904 213.707 94.6656 207.408 94.6656C204.812 94.6656 202.708 92.5613 202.708 89.9656V86.8616C202.708 84.2659 204.812 82.1616 207.408 82.1616C220.602 82.1616 231.336 92.8925 231.336 106.086L206.408 124.006ZM206.408 124.006C206.408 127.243 209.115 130.211 212.586 129.442C223.3 127.071 231.338 117.503 231.336 106.087L206.408 124.006Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.715 144.334H237.219C240.464 144.334 243.402 141.632 242.71 138.169C240.303 126.126 229.65 117.025 216.904 117.025H213.307C209.993 117.025 207.307 119.711 207.307 123.025V123.529C207.307 126.842 209.993 129.529 213.307 129.529H216.904C222.913 129.529 228.042 133.388 229.936 138.76C230.926 141.568 233.353 144.334 236.715 144.334Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.371 150.599H39.9824C36.6687 150.599 33.9824 153.285 33.9824 156.599V158.378C33.9824 161.692 36.6687 164.378 39.9824 164.378H105.371C108.685 164.378 111.371 161.692 111.371 158.378V156.599C111.371 153.285 108.685 150.599 105.371 150.599Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.834 150.599H176.624C173.31 150.599 170.624 153.285 170.624 156.599V158.378C170.624 161.692 173.31 164.378 176.624 164.378H240.834C244.148 164.378 246.834 161.692 246.834 158.378V156.599C246.834 153.285 244.148 150.599 240.834 150.599Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 340,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaygroundPsychflex);
export default __webpack_public_path__ + "static/media/playground-psychflex.e7b18664.svg";
export { ForwardRef as ReactComponent };